import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const lpgPaymentSettingsEditCard: IMcAppType = {
  name: "lpgPaymentSettingsEditCard",
  path: "/my/payment-settings/lpg/update-card-expiry",
  description: "Update the card expiry for lpg",
  navFlow: NavFlow.FOCUS,
  title: "Update card expiry",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "lpgPaymentSettingsEditCard",
  },
};
